import React, { useEffect, useState } from 'react'
import { EmptyStateTextOnly } from 'src/components/Reusable/Text/EmptyStateTextOnly'
import { NoFilterResults } from 'src/components/PageLayout/NoFilterResults'
import { PoliciesAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { EmptyStateTextOnlySize } from 'src/components/Reusable/Text/EmptyStateTextOnly.constants'
import { ControlsListItem } from '../../IndexItem'
import { ControlGridRowsProps } from './ControlsIndexPage.constants'

export const getControlsGridEmptyState = (): JSX.Element => {
  const isPoliciesPage = location.pathname.includes(PoliciesAbsoluteRoutes.SHOW)
  // dodging a circular dependency here. need to clean it up and use a const
  const isRequestsPage = location.pathname.includes('requests/show')

  if (isPoliciesPage) {
    return (
      <EmptyStateTextOnly
        size={EmptyStateTextOnlySize.SMALL}
        text="No controls support this policy. Set this per control."
      />
    )
  } else if (isRequestsPage) {
    return (
      <EmptyStateTextOnly
        size={EmptyStateTextOnlySize.SMALL}
        text="No controls linked to this request. Try linking one. You can unlink it easily."
      />
    )
  } else {
    return <NoFilterResults />
  }
}

const BATCH_SIZE = 100 // Number of items to load in each batch
const LOAD_INTERVAL = 150

export const ControlGridRows = ({
  controls,
  audit,
  config,
  policyNamesByControlId = {},
  departmentNamesByControlId = {},
}: ControlGridRowsProps): JSX.Element => {
  const [visibleItems, setVisibleItems] = useState<number>(BATCH_SIZE)

  useEffect(() => {
    if (visibleItems < controls.length) {
      const timer = setInterval(() => {
        setVisibleItems((prev) => Math.min(prev + BATCH_SIZE, controls.length))
      }, LOAD_INTERVAL)

      return () => clearInterval(timer) // Clear the timer on unmount or when all items are loaded
    }
  }, [visibleItems, controls.length])

  return (
    <>
      {controls.slice(0, visibleItems).map((control) => (
        <ControlsListItem
          key={control.getModelId()}
          controlModelId={control.getModelId()}
          audit={audit}
          config={config}
          linkedPolicyNames={policyNamesByControlId[control.getId()] || []}
          linkedDepartmentNames={
            departmentNamesByControlId[control.getId()] || []
          }
        />
      ))}
    </>
  )
}
